// login apis
export const LOGIN_API = '/CustomerLogin';
export const LOGOUT_API = '/CustomerLogout';
export const FORGOT_PASSWORD_API = '/CustomerForgotPassword';
export const RESET_PASSWORD_API = '/CustomerResetPassword';

// kitchen apis
export const GET_KITCHEN_BY_ZIPCODE_API = '/GetServingZipcode';

export const MEAL_PACKAGES_API = '/GetMealPackages';

// customer apis
export const CREATE_FUTURE_CUSTOMER_API = '/CreateFutureCustomer';

// creates a new user
export const SIGN_UP_USER_API = '/CustomerSignup';

// generates email verification OTP
export const GENERATE_OTP_API = '/OtpCustomerEmailVerify?serviceType=generateOtp';

// verifies email OTP
export const VERIFY_OTP_API = '/OtpCustomerEmailVerify?serviceType=verifyOtpNo';

export const CHECKOUT_TRANSACTION_API = '/SubscriptionTransaction';

export const ADD_DELIVERY_ADDRESS_API = '/AddDeliveryAddress';

export const GET_DELIVERY_ADDRESS_API = '/GetDeliveryAddress';

export const UPDATE_DELIVERY_ADDRESS_API = '/UpdateDeliveryAddress';

export const DELETE_DELIVERY_ADDRESS_API = '/DeleteDeliveryAddress';

export const COUPON_DISCOUNT_API = '/GetDiscount';
export const ONLOAD_INFORMATION_API = '/OnLoadInformation';
export const URL_VALIDATION_API = '/UrlValidation';

// New Routes
// API To get products based on kitchen and serving day ( Mandatory Keys : "kitchen_names, status, email, serving_size, device" )
export const GET_PRODUCTS_API = '/GetProduct';
export const CARD_UPDATE_API = '/CardUpdate';
export const GET_KITCHENS_API = '/GetKitchens';
export const CUSTOMER_INFO_API = '/CustomerInfo';
export const UPDATE_CREDIT_CARD = '/CardUpdate';
export const REGULAR_MENU_ORDER_API = '/PayAsYouGoOrder'; // PayAsYouGoOrder non meal items
export const MEAL_MENU_ORDER_API = '/MealOrder'; // Meal items   We no longer using this ,as meal item are passed in payasyougo api (5/1/2026)
export const DISCOUNT_CODE_VALIDATION_API = '/GetDiscount';
export const GET_ORDER_STATUS = '/GetKitchenOrders';
export const WAITLIST_FOUNDING_MEMBER_API = '/WaitListFoundingMember';
export const REPORT_UI_BUG_API = '/ReportUiBugCustomer';
